import Axios from 'axios'

const steps = [
   { title: 'Kaupunki', component: 'Area', completed: false, active: true },
   { title: 'Lapsen tiedot', component: 'Child', completed: false, active: false },
   { title: 'Huoltajien tiedot', component: 'Caretakers', completed: false, active: false },
   { title: 'Toiminta-aika iltapäivätoiminnassa', component: 'Need', completed: false, active: false },
   { title: 'Lisätiedot', component: 'Info', completed: false, active: false },
   { title: 'Yhteenveto', component: 'Summary', completed: false, active: false }
]

const caretakerTemplate = {
   firstname: '',
   lastname: '',
   address: {
      street: '',
      zip: '',
      city: ''
   }
}

const store = {
   state: {
      activeStepIndex: 0,

      activeStep: steps[0],

      applicationSent: false,

      steps: steps,

      area: null,

      child: {
         firstname: '',
         lastname: '',
         address: {
            street: '',
            zip: '',
            city: ''
         },
         schoolAndClass: '',
         friends: '',
         allergies: '',
         specialNeeds: '',
         schoolRide: false,
         rideArrival: '',
         rideDeparture: '',
         dataPassRequest: false,
         photographyRequest: false,
         comments: ''
      },

      caretakers: [
         {
            firstname: '',
            lastname: '',
            address: {
               street: '',
               zip: '',
               city: ''
            }
         }
      ],

      need: {
         startdate: {
            day: '',
            month: '',
            year: ''
         },
         option: ''
      },

      comments: '',

      approveTerms: false
   },

   copyChildAddressForCaretaker (caretaker) {
      caretaker.address = { ...this.state.child.address }
   },

   addCaretaker () {
      this.state.caretakers.push({ ...caretakerTemplate })
   },

   removeCaretaker (index) {
      if (window.confirm('Haluatko varmasti poistaa huoltajan hakemukselta?')) {
         this.state.caretakers.splice(index, 1)
      }
   },

   nextStep () {
      const oldIndex = this.state.activeStepIndex
      const newIndex = this.state.activeStepIndex + 1
      this.state.activeStepIndex = newIndex
      this.state.activeStep = this.state.steps[newIndex]
      this.state.steps = this.state.steps.map(step => { return { ...step, active: false } })
      this.state.steps[newIndex].active = true
      this.state.steps[oldIndex].completed = true
   },

   prevStep () {
      const oldIndex = this.state.activeStepIndex
      const newIndex = this.state.activeStepIndex - 1
      this.state.activeStepIndex = newIndex
      this.state.activeStep = this.state.steps[newIndex]
      this.state.steps[oldIndex].active = false
      this.state.steps[newIndex].active = true
   },

   submitApplication () {
      const payload = {
         area: this.state.area,
         child: this.state.child,
         caretakers: this.state.caretakers,
         need: this.state.need,
         comments: this.state.comments
      }

      Axios.post(process.env.VUE_APP_API_URL + '/api/public/v1/inbound/afterschool', payload).then(
         function (success) { console.log(success) },
         function (error) { console.error(error) }
      )

      this.state.applicationSent = true
   },

   isLastStep () {
      return this.state.activeStepIndex === (this.state.steps.length - 1)
   },

   isFirstStep () {
      return this.state.activeStepIndex === 0
   },

   // Validation rules
   validate (componentName) {
      if (componentName === 'Area') return this.validateArea()
      if (componentName === 'Child') return this.validateChild()
      if (componentName === 'Caretakers') return this.validateCaretakers()
      if (componentName === 'Need') return this.validateNeed()
      if (componentName === 'Summary') return this.validateSummary()

      return { valid: true, message: '' }
   },

   validateChild () {
      if (this.state.child.firstname === '' ||
         this.state.child.lastname === '' ||
         this.state.child.address.street === '' ||
         this.state.child.address.city === '' ||
         this.state.child.address.zip === '') {
         return { valid: false, message: '' }
      }

      return { valid: true, message: '' }
   },

   validateArea () {
      if (this.state.area === '' || this.state.area === null) return { valid: false, message: 'Valitse iltapäiväkerhon kaupunki jatkaaksesi' }
      return { valid: true, message: '' }
   },

   validateCaretakers () {
      if (this.state.caretakers.length < 1) return { valid: false, message: 'Syötä ainakin yksi huoltaja jatkaaksesi' }

      const caretakerIsValid = (caretaker) => {
         if (caretaker.firstname === '' ||
            caretaker.lastname === '' ||
            caretaker.email === '' ||
            caretaker.phone === '' ||
            caretaker.address.street === '' ||
            caretaker.address.city === '' ||
            caretaker.address.zip === '') {
            return false
         }

         return true
      }

      if (!this.state.caretakers.every(caretakerIsValid)) {
         return { valid: false, message: '' }
      }

      return { valid: true, message: '' }
   },

   validateNeed () {
      if (!this.state.need.option) return { valid: false, message: 'Valitse hoidon tarve jatkaaksesi' }

      return { valid: true, message: '' }
   },

   validateSummary  () {
      if (!this.state.approveTerms) return { valid: false, message: 'Vahvista tiedojen oikeellisuus lähettääksesi hakemuksen' }
      return { valid: true, message: '' }
   },

   approveTerms () {
      this.state.approveTerms = !this.state.approveTerms
   },

   toggleSchoolRide () {
      this.state.child.schoolRide = !this.state.child.schoolRide
   },

   approveDataPass () {
      this.state.child.dataPassRequest = !this.state.child.dataPassRequest
   },

   approvePhotography () {
      this.state.child.photographyRequest = !this.state.child.photographyRequest
   },

   selectCity (city) {
      this.state.area = city
   }
}

export default store
